import Vue from 'vue'
import Vuex from 'vuex'
import { getData } from '@/services/httpService'
import {
  handleDepartmentParameters,
  handleLocationParameters,
  handleKeywordSearch,
  handlePageNumber,
  handleTeamParameters,
} from '@/utility/index'
import filters from './modules/filters'
import pageNumber from './modules/pageNumber'
import queryParams from './modules/queryParams'
import results from './modules/results'
import { handleFilterSelection } from './plugins/handleFilterSelection'
import { handlePageNumbers } from './plugins/handlePageNumbers'
import { handleQueryParams } from './plugins/handleQueryParams'

Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    async populateFilters({ commit }) {
      const response = await getData()
      commit('results/setCareersData', response)
      commit('results/setCurrentResults', response)

      let locationFilters = []
      let departmentFilters = []
      let teamFilters = []
      for (let i = 0; i < response.length; i++) {
        const { department, location, team } = response[i]

        if (!departmentFilters.includes(department) && department) {
          departmentFilters.push(department)
        }

        if (!locationFilters.includes(location) && location) {
          locationFilters.push(location)
        }

        if (!teamFilters.includes(team) && team) {
          teamFilters.push(team)
        }
      }

      commit('filters/setDepartmentFilters', departmentFilters, { root: true })
      commit('filters/setLocationFilters', locationFilters.sort(), { root: true })
      commit('filters/setTeamFilters', teamFilters, { root: true })
    },
    async handleQueryParams() {
      if (window.location.search !== '') {
        const search = new URLSearchParams(window.location.search)
        handleDepartmentParameters(search.get('department'))
        handleLocationParameters(search.get('location'))
        handleKeywordSearch(search.get('search'))
        handlePageNumber(search.get('pageNumber'))
        handleTeamParameters(search.get('team'))
      }
    }
  },
  modules: {
    filters,
    pageNumber,
    queryParams,
    results,
  },
  plugins: [handleFilterSelection, handleQueryParams, handlePageNumbers]
})
